module.exports = __webpack_public_path__ + "static/images/f44018e0269271ee0059498d4ca5c586.png";